type Refresh = () => unknown | Promise<unknown>;

export const refreshAfterTransaction = (refreshes: Refresh[]) =>
  Promise.allSettled(
    refreshes.map((refresh) => Promise.resolve().then(refresh))
  );
